module.exports = __webpack_public_path__ + "img/kaftor_no.21d86f9d.png";